export default "__VITE_ASSET__6bce6d67__"